import {
  DIRTY_CLASS,
  VALIDATION_ERROR_CLASS,
  INPUT_INVALID_CLASS,
  DISABLED_SUBMIT_INPUT,
} from './constants';

export var isValidatable = (input) => {
  var classes = input.classList;
  return Array.prototype.indexOf.call(classes, DIRTY_CLASS) > -1
    || Array.prototype.indexOf.call(classes, 'form__input--invalid') > -1;
};

export var findOrCreateErrorNode = ({
  errorMessage,
  input,
  cb,
}) => {
  if (isValidatable(input)) {
    let parentNode;
    if (cb) {
      parentNode = cb(input);
    } else {
      var { parentNode: { parentNode: parent } } = input;
      parentNode = parent;
    }

    var errorNode = parentNode.querySelector(`.${VALIDATION_ERROR_CLASS}`) || document.createElement('div');
    errorNode.classList.add(VALIDATION_ERROR_CLASS);
    if (errorMessage) {
      errorNode.textContent = errorMessage;
    } else {
      errorNode.textContent = input.validationMessage;
    }

    input.classList.add(INPUT_INVALID_CLASS);
    parentNode.appendChild(errorNode);
  }
};

export var removeErrorNode = (input, cb) => {
  let parentNode;
  if (cb) {
    parentNode = cb(input);
  } else {
    var { parentNode: { parentNode: parent } } = input;
    parentNode = parent;
  }

  var errorNode = parentNode.querySelector(`.${VALIDATION_ERROR_CLASS}`);
  input.classList.remove(INPUT_INVALID_CLASS);
  if (errorNode && parentNode === errorNode.parentNode) {
    parentNode.removeChild(errorNode);
  }
};

export var toggleSubmitButton = function (...args) {
  let form;
  if (args[0] && args[0].nodeName && args[0].nodeName.toLowerCase() === 'form') {
    [form] = args;
  } else {
    form = args[0].currentTarget;
  }

  var submit = form.querySelector('input[type="submit"]');

  form.checkValidity();
  if (form.checkValidity()) {
    submit.classList.remove(DISABLED_SUBMIT_INPUT);
    submit.disabled = false;
    return;
  }
  submit.classList.add(DISABLED_SUBMIT_INPUT);
  submit.disabled = true;
};

export var makeDirty = (input) => {
  input.classList.add(DIRTY_CLASS);
};

export default {
  isValidatable,
  findOrCreateErrorNode,
  makeDirty,
  removeErrorNode,
};
